import React, {Component, Fragment} from 'react'
import Link from "next/link";
import {applyLang, LangSelect} from "../../../../../i18n";
import {buildDynamicArticlesMenuItems, buildContentHubHomeUrlForSite} from "../../../../../components/ContentHub/utils";
import {buildMenuUrl} from "../../../../../components/normalizeMenuUrl";
import {t} from "@lingui/core/macro"
import {Trans} from "@lingui/react/macro"

export default class MobileMenu extends Component {

    state = {
        isMenuShow: false,
        isOpen: [],
    }

    menuHandler = () => {
        this.setState({
            isMenuShow: !this.state.isMenuShow
        })
    }

    setRemoveOpen = id => () => {
        this.setState({
            isOpen: this.state.isOpen.filter(i=>i!==id)
        })
    }

    setAddOpen = id => () => {
        this.setState({
            isOpen: [...this.state.isOpen,id]
        })
    }

    setIsOpen = id => () => {
        this.setState({
            isOpen:this.state.isOpen.includes(id)?[]:[id]
        })
    }

    getCaisse()
    {
        const {org}=this.props.context

        return org.caisses
            .filter((c)=>( c.total<c.objectif || !c.withObjectif) && c.active && !c.paused && !c.hidden )
            .sort((a,b)=>a.withObjectif - b.withObjectif)
            .map(i=>applyLang(i,this.props.context.lang))
    }

    renderCaisses()
    {
        const {org,config}=this.props.context
        const caisses=this.getCaisse()
        const { isOpen } = this.state;

        if(caisses.length===0){
            return null
        }

        var mainLabel=config["don.main.label"] ||  t`Don Spontané`

        return(
            <div style={{padding:"0px 5px",display:isOpen.includes("DON")?"block":"none"}}>
                <ul>
                    <li><Link href={org.BASE_WEB_URL+"/don"}>{mainLabel}</Link></li>
                    {caisses.map(item=>{
                        return(
                            <li key={item.id}>
                                <Link href={org.BASE_WEB_URL+"/don/"+item.id}>
                                    {item.name}
                                </Link>
                            </li>
                        )
                    })}
                </ul>
            </div>
        )
    }

    // Menu enrichi (web_menu + items virtuels récursifs des menus dynamiques),
    // mémoïsé. Cf. themes/Ummah/header.js getEffectiveMenu.
    getEffectiveMenu()
    {
        if(this._effectiveMenu) return this._effectiveMenu
        const {org, contentHubCategories}=this.props.context
        const base=org.web_menu || []
        const site=contentHubCategories?.site
        let extra=[]
        for(const m of base){
            if(m && m.type==="DYNAMIC_ARTICLES"){
                extra=extra.concat(buildDynamicArticlesMenuItems(contentHubCategories?.items, m.id, site, org))
            }
        }
        this._effectiveMenu=[...base, ...extra]
        return this._effectiveMenu
    }

    renderChildMenu(parent)
    {
        const context=this.props.context
        const {org}=context
        const fullMenu=this.getEffectiveMenu()
        const menu=fullMenu.filter(i=>i.parent===parent)
        const { isOpen } = this.state;

        if(menu.length===0){
            return null
        }

        return(
            <div style={{padding:"0px 5px",display:isOpen.includes(parent)?"block":"none"}}>
                <ul>
                    {menu.map(item => {
                        item=applyLang(item,context.lang)
                        // buildMenuUrl gère relatif, absolu-réécrit, slug nu (préfixé)
                        // et schémas (intacts) — cf. components/normalizeMenuUrl.js.
                        const url=buildMenuUrl(item.url, org)
                        const isSubExist=fullMenu.filter(i=>i.parent===item.id).length>0
                        return(
                            <li key={item.id}>
                                {isSubExist ? (
                                    <p onClick={isOpen.includes(item.id)?this.setRemoveOpen(item.id):this.setAddOpen(item.id)}>
                                        {item.name}
                                        {!isOpen.includes(item.id)
                                            ? <i className="fa fa-angle-right" aria-hidden="true"></i>
                                            : <i className="fa fa-angle-down" aria-hidden="true"></i>}
                                    </p>
                                ) : (
                                    <Link href={url}>{item.name}</Link>
                                )}
                                {this.renderChildMenu(item.id)}
                            </li>
                        )
                    })}
                </ul>
            </div>
        )
    }

    render() {

        const context=this.props.context
        const {org,config}=context
        const menu=org.web_menu
        const { isMenuShow, isOpen } = this.state;
        const caisses=this.getCaisse()

        return (
            <div>
                <div className={`mobileMenu ${isMenuShow ? 'show' : ''}`}>
                    <ul className="responsivemenu">
                        <LangSelect context={context}/>

                        {!org.limited && (
                            <Fragment>
                                {menu.filter(i=>!i.parent).map(rawItem => {
                                    const isDynamic = rawItem.type === "DYNAMIC_ARTICLES"
                                    const item=applyLang(rawItem,context.lang)
                                    let url=item.url || ""
                                    if(isDynamic){
                                        url=buildContentHubHomeUrlForSite(org, context.contentHubCategories?.site)
                                    } else {
                                        url=buildMenuUrl(url, org)
                                    }
                                    // Pour un menu dynamique on a TOUJOURS un sous-menu (les catégories ContentHub).
                                    const isSubExist=isDynamic || this.getEffectiveMenu().filter(i=>i.parent===rawItem.id).length>0
                                    return (
                                        <li key={rawItem.id}>
                                            {isSubExist ? (
                                                <p onClick={this.setIsOpen(rawItem.id)}>
                                                    {item.name}
                                                    {!isOpen.includes(rawItem.id)
                                                        ? <i className="fa fa-angle-right" aria-hidden="true"></i>
                                                        : <i className="fa fa-angle-down" aria-hidden="true"></i>}
                                                </p>
                                            ) : (
                                                <Link href={url}>{item.name}</Link>
                                            )}
                                            {this.renderChildMenu(rawItem.id)}
                                        </li>
                                    )
                                })}

                                {config["menu.galerie.active"]!==false && (
                                    <li><Link href={org.BASE_WEB_URL+"/galeries"}>{t`Galeries`}</Link></li>
                                )}
                                {config["menu.event.active"]!==false && (
                                    <li><Link href={org.BASE_WEB_URL+"/evenements"}>{t`Événements`}</Link></li>
                                )}
                                {config["menu.abo.active"]!==false && (
                                    <li><Link href={org.BASE_WEB_URL+"/abonnements"}>{t`Abonnements`}</Link></li>
                                )}
                                {config["menu.horaire.active"]!==false && (
                                    <li><Link href={org.BASE_WEB_URL+"/horaires"}>{t`Horaires`}</Link></li>
                                )}
                                {config["menu.don.active"]!==false && caisses.length===0 && (
                                    <li>
                                        <Link href={org.BASE_WEB_URL+"/don"}>{t`Don Spontané`}</Link>
                                    </li>
                                )}
                                {config["menu.don.active"]!==false && caisses.length>0 && (
                                    <li>
                                        <p onClick={this.setIsOpen("DON")}>
                                            {t`Don Spontané`}
                                            {!isOpen.includes("DON")
                                                ? <i className="fa fa-angle-right" aria-hidden="true"></i>
                                                : <i className="fa fa-angle-down" aria-hidden="true"></i>}
                                        </p>
                                        {this.renderCaisses()}
                                    </li>
                                )}
                            </Fragment>
                        )}

                        {org.limited && (
                            <li>
                                <Link href={org.BASE_WEB_URL}>{t`Accueil`}</Link>
                            </li>
                        )}
                    </ul>

                </div>

                <div className="showmenu" onClick={this.menuHandler}>
                    <i className="fa fa-bars" aria-hidden="true"></i>
                </div>
            </div>
        )
    }
}
